

var Isotope = require('isotope-layout');
let gridFilterButtons = document.querySelectorAll(".js-filter-button");
let searchFilter;
let buttonFilter;
let contentSearchInput;
let $iso = null;
let opts = {
    itemSelector: '.content-card',
    resize: false,
    transitionDuration: 'none',
    layoutMode: 'no-shuffle',
            hiddenStyle: {
                opacity: 0
              },
              visibleStyle: {
                opacity: 1
            },
    filter: (card) => {
      let searchResult = searchFilter ? card.textContent.match( searchFilter ) : true;
      let buttonResult = buttonFilter ? card.matches( buttonFilter ) : true;
      return searchResult && buttonResult;
    }
  };


  Isotope.Item.prototype._create = function() {
    // assign id, used for original-order sorting
    this.id = this.layout.itemGUID++;
    // transition objects
    this._transn = {
      ingProperties: {},
      clean: {},
      onEnd: {}
    };
    this.sortData = {};
  };
  
//   Isotope.Item.prototype.layoutPosition = function() {
//     this.emitEvent( 'layout', [ 'this' ] );
    
//   };

  
  Isotope.prototype.arrange = function(  ) {
    // set any options pass
    this.option( opts );
    this._getIsInstant();
    // just filter
    this.filteredItems = this._filter( this.items );
   
    this.filteredItems.needHide.forEach((item) => {
        item.element.classList.add('is-hidden');
    });
    this.filteredItems.matches.forEach((item) => {
        item.element.classList.remove('is-hidden');
    });
       // flag for initalized
    this._isLayoutInited = true; 
  };

  // layout mode that does not position items
  Isotope.LayoutMode.create('no-shuffle');

  function debounce( fn, threshold ) {
    var timeout;
    threshold = threshold || 100;
    return function debounced() {
      clearTimeout( timeout );
      var args = arguments;
      var _this = this;
      function delayed() {
        fn.apply( _this, args );
      }
      timeout = setTimeout( delayed, threshold );
    };
  }

Isotope.LayoutMode.create('no-shuffle');

const initIsotope = (s, w) => {
        
    if (w !== null) {
        $iso = new Isotope(w, {
            layoutMode: 'no-shuffle',
            ...opts});

        if (contentSearchInput !== null) {
            contentSearchInput.addEventListener("keyup", (e) => {
                    searchFilter = new RegExp( e.target.value, 'gi' );
                    $iso.arrange(opts);
                }
            );
            contentSearchInput.addEventListener("search", (e) => {
                clearSearch();
                clearIsActiveButtons();
                setFirstActiveButton();
            }
        );
        }
        $iso.once( 'layoutComplete', function() {
            // loaded, add loaded class
            //w.classList.add('is-loaded')
            console.log('is-loaded')
        });
    }
}

document.addEventListener("DOMContentLoaded", function() {
    // find element with data-isotope;
    const isotopeContent = document.querySelector('.js-isotope');
    if (isotopeContent !== null) {
        const selector = isotopeContent.dataset.selector;
        const wrapper = document.querySelector(isotopeContent.dataset.wrapper);
        contentSearchInput = document.querySelector(isotopeContent.dataset.searchInput)
        initIsotope(selector, wrapper);
    }
    
});

const clearIsActiveButtons = () => {
    gridFilterButtons.forEach((filterButton) => {
        filterButton.classList.remove('is-active');
    });
}

const setFirstActiveButton = () => {
    gridFilterButtons.forEach((filterButton, index) => {
        if (index === 0) {
            filterButton.classList.add('is-active');
        }
    });
}

const clearSearch = () => {
    searchFilter = null;
    buttonFilter = null;
    contentSearchInput.value = "";
    $iso.arrange(opts);
}

if (gridFilterButtons !== null) {
    gridFilterButtons.forEach((filterButton) => {
    filterButton.addEventListener("click", () => {
            clearIsActiveButtons();
            buttonFilter = filterButton.dataset.filter
            if (buttonFilter == "*") {
                clearSearch();
            } else {
            filterButton.classList.add('is-active');
            $iso.arrange(opts);
            }
        }
    );
    });
}

